import React, { HTMLAttributes } from "react";

import { cn } from "@/utils/general";

import styles from "./ModalNova.module.css";

interface BaseProps extends HTMLAttributes<HTMLElement> {
  className?: string;
  fullHeightMobile?: boolean;
}

// Backdrop
const Backdrop: React.FC<BaseProps> = ({ className, fullHeightMobile = false, ...props }) => (
  <div
    className={`${styles.backdrop} ${fullHeightMobile ? styles.backdropFullHeightMobile : ""} ${className || ""}`}
    {...props}
  />
);

// Dialog
interface DialogProps extends BaseProps {
  maxWidth?: string | number;
  open?: boolean;
}

const Dialog: React.FC<DialogProps> = ({ maxWidth, className, style, ...props }) => (
  <dialog
    className={`${styles.dialog} ${className || ""}`}
    style={{
      background: "#fff",
      maxWidth,
      ...style,
    }}
    {...props}
  />
);

// ScrollWrapper
const ScrollWrapper: React.FC<BaseProps> = ({ className, ...props }) => (
  <div className={`${styles.scrollWrapper} ${className || ""}`} {...props} />
);

// ModalHeader
interface ModalHeaderProps extends BaseProps {
  hasTitle?: boolean;
}

const ModalHeader: React.FC<ModalHeaderProps> = ({ hasTitle, className, ...props }) => (
  <div
    className={cn(
      styles.modalHeader,
      hasTitle ? "pt-10 pb-8 px-6 md:pt-10 md:pb-10" : "pt-10 px-6",
      "bg-nova-base-white",
      className
    )}
    {...props}
  />
);

// CloseTrigger
const CloseTrigger: React.FC<BaseProps> = ({ className, ...props }) => (
  <button
    className={`${styles.closeTrigger} ${className || ""}`}
    style={{ background: "#FFC942" }}
    {...props}
  />
);

// ModalBody
interface ModalBodyProps extends BaseProps {
  hasBodyPadding?: boolean;
}

const ModalBody: React.FC<ModalBodyProps> = ({ hasBodyPadding, className, ...props }) => (
  <div className={`${hasBodyPadding ? styles.modalBody : ""} ${className || ""}`} {...props} />
);

export { Backdrop, Dialog, ScrollWrapper, ModalHeader, CloseTrigger, ModalBody };
